export default "__VITE_ASSET__DXuBdIHV__"